<template>

  <HeaderCredencialSection />

  <section id="formulario" class="bg-gray-100 py-6" >

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700">

      <div class="container mx-auto px-4 lg:px-40 max-w-5xl">

        <h1 class="font-bold text-gray-800 mb-0 text-2xl text-center pt-5 pb-1">
          CREDENCIALES DE VISITANTES
        </h1>
        <h1 class="text-gray-800 mb-4 text-xl text-center pt-2 pb-5">
          Complete el siguiente formulario para descargar su credencial
        </h1>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 ">
            <label class="block mb-1">DNI / Pasaporte</label>
            <Field name="documento" v-slot="{ field, errors }" v-model="formData.documento">
              <InputText v-bind="field" type="numeric"  placeholder="Documento / Pasaporte"  class="w-full p-inputtext-sm p-3 text-sm rounded-lg border" :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="documento" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit" label="REGISTRARME" class="mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>DESCARGAR CREDENCIAL
          </button>
        </div>

      </div>

    </Form>

  </section>

  <FullScreenLoader :visible="isSubmitting" fullScreen />

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import HeaderCredencialSection from './HeaderCredencialSection.vue';
import FullScreenLoader from '@/components/FullScreenLoader.vue';

import suiteService, { Acreditado, IdLabelEntity } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';

interface TipoAcreditacion extends IdLabelEntity {}

export default defineComponent({
  components: {
    HeaderCredencialSection,
    InputText, FullScreenLoader,
    Field, ErrorMessage, Form
  },
  created () {
    document.title = "BATEV 2026 - Credenciales";
  },
  data() {
    return {
      tiposAcreditaciones: [] as TipoAcreditacion[],
      isSubmitting: false,
      formData: {
        tipoAcreditacion: undefined as unknown as TipoAcreditacion,
        documento: '',
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        documento: yup.string().required('Ingrese su documento').min(7, 'Al menos 7 números'),
      });
    }
  },
  methods: {
    async onSubmit() {
      this.isSubmitting = true;

      let acreditado:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni="+this.formData.documento) as Acreditado;
      if(!acreditado) {
        this.isSubmitting = false;
        Swal.fire({ 
            title: "Atención", 
            html: "El acreditado no existe<br/>",
            icon: "error"
        });
        return;
      }
			
      try {
        location.href = "https://apps.qreventos.com/credencial/getCredencial?evento=" + suiteConfig.evento + "&hash=" + acreditado.hash;
      } finally {
        this.isSubmitting = false;
      }
    }
  }
});
</script>
